import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesListItemDescriptionCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
};

const ApiKeyRolesListItemDescriptionCell = ({
  roleBinding,
}: ApiKeyRolesListItemDescriptionCellProps) => {
  const handleShowFullDescription = () => {
    // TODO: Add analytics when implemented
  };

  if (!roleBinding.role.description) {
    return null;
  }

  return (
    <Box direction="row" align="center">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={roleBinding.role.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </Box>
  );
};

export default ApiKeyRolesListItemDescriptionCell;
